<template>
  <div>
    <v-tabs v-model="activeTab" centered grow show-arrows class="d-print-none">
      <v-tab
        v-if="profile.is_staff"
        key="tab-0"
        v-translate
        :to="{ name: 'EditShow', params: { id: $route.params.id } }"
      >
        Dettagli
      </v-tab>
      <v-tab
        key="tab-0q"
        v-translate
        :to="{ name: 'ShowPersonOptions', params: { id: $route.params.id } }"
      >
        Generale
      </v-tab>
      <v-tab
        v-if="profile.is_staff"
        key="tab-0z"
        v-translate
        :to="{ name: 'ShowCalendar', params: { id: $route.params.id } }"
      >
        Calendario
      </v-tab>
      <v-tab
        key="tab-0a"
        v-translate
        :to="{ name: 'ShowEvents', params: { id: $route.params.id } }"
      >
        Eventi
      </v-tab>
      <v-tab
        key="tab-0b"
        v-translate
        :to="{ name: 'ShowConcerts', params: { id: $route.params.id } }"
      >
        Programmi
      </v-tab>
      <v-tab
        v-if="profile.is_staff"
        key="tab-0c"
        v-translate
        :to="{
          name: 'ShowConcertCategories',
          params: { id: $route.params.id },
        }"
      >
        Percorsi
      </v-tab>
      <v-tab
        v-if="profile.is_staff"
        key="tab-1"
        v-translate
        :to="{ name: 'ShowPeople', params: { id: $route.params.id } }"
      >
        Persone
      </v-tab>
      <v-tab
        v-if="profile.is_staff"
        key="tab-2"
        v-translate
        :to="{ name: 'ShowBands', params: { id: $route.params.id } }"
      >
        Gruppi
      </v-tab>
      <v-tab
        v-if="profile.is_staff"
        key="tab-3"
        v-translate
        :to="{ name: 'ShowInstruments', params: { id: $route.params.id } }"
      >
        Strumenti
      </v-tab>
      <v-tab
        v-if="profile.is_staff"
        key="tab-4"
        v-translate
        :to="{ name: 'ShowPlaces', params: { id: $route.params.id } }"
      >
        Luoghi
      </v-tab>

      <v-tab
        v-if="profile.is_staff"
        key="tab-5"
        v-translate
        :to="{ name: 'ShowHotels', params: { id: $route.params.id } }"
      >
        Hotel
      </v-tab>
      <v-tab
        v-if="profile.is_staff"
        key="tab-6"
        v-translate
        :to="{ name: 'ShowRooms', params: { id: $route.params.id } }"
      >
        Stanze
      </v-tab>
      <v-tab
        key="tab-7"
        v-translate
        :to="{ name: 'ShowBookings', params: { id: $route.params.id } }"
      >
        Prenotazioni
      </v-tab>
      <v-tab
        key="tab-8"
        v-translate
        v-if="profile.is_staff"
        :to="{ name: 'ShowHotelsTableEndpoint', params: { id: $route.params.id } }"
      >
        Tabella hotel
      </v-tab>
      <v-tab
        key="tab-9"
        v-translate
        :to="{ name: 'ShowTransports', params: { id: $route.params.id } }"
      >
        Trasporti
      </v-tab>
      <v-tab
        key="tab-10"
        v-translate
        :to="{ name: 'ShowVouchers', params: { id: $route.params.id } }"
      >
        Buoni Pasto
      </v-tab>
      <v-tab
        v-if="profile.is_staff"
        key="tab-11"
        v-translate
        :to="{ name: 'ShowExport', params: { id: $route.params.id } }"
      >
        Export
      </v-tab>
      <v-tab
        key="tab-12"
        v-translate
        v-if="profile.is_staff"
        :to="{ name: 'ShowAggregatedData', params: { id: $route.params.id } }"
      >
        Cruscotto
      </v-tab>
    </v-tabs>

    <router-view></router-view>
  </div>
</template>

<script>
// import { mapState } from "vuex"

export default {
  data() {
    return {
      activeTab: null,
    }
  },
}
</script>
